import { render } from "./DeveloperItemText.vue?vue&type=template&id=f60ef966"
import script from "./DeveloperItemText.vue?vue&type=script&lang=js"
export * from "./DeveloperItemText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__